import { createDecorator } from '../../instantiation/common/instantiation.js';
const IExtensionResourceLoaderService = ( createDecorator('extensionResourceLoaderService'));
export { IExtensionResourceLoaderService };
